/**
 * There is some problem in tanstack form with removing value
 * or setting it to undedefined, due to which
 * we need to set null value for some fields.
 *
 * Issue: https://github.com/TanStack/form/issues/1289
 */
export const removeNulls = (obj) =>
  Object.entries(obj).forEach(([key, value]) => {
    if (value == null) {
      delete obj[key];
    } else if (typeof value === 'object' && !Array.isArray(value)) {
      removeNulls(value);
    }
  });
